import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { UaService } from '@ecm/consumer';
import { QrCodePipe } from '@ecm/material';

import { ButtonViewModel } from '../../../../business/model/home/button.view-model';
import { BreakpointService } from '../../../../services/breakpoint.service';

@Component({
    selector: 'forbidden-banner',
    templateUrl: 'forbidden-banner.component.html',
    styleUrls: ['./forbidden-banner.component.css'],
    standalone: true,
    imports: [CommonModule, QrCodePipe, TranslateModule],
})
export class ForbiddenBannerComponent {
    public constructor(
        private readonly breakpointService: BreakpointService,
        protected uaService: UaService,
        private readonly translate: TranslateService,
    ) {}
    @Input()
    public model: any;

    @Output()
    public readonly badgeClick = new EventEmitter<ButtonViewModel>();

    public isMobileWidth = toSignal(this.breakpointService.isMobileWidth());
    public qrCodeUrl = this.translate.instant('dashboard.forbidden.protectedHouseV2.banner.qrCode.url');
    public detailAriaLabel = this.translate.instant('dashboard.forbidden.protectedHouseV2.banner.detailAriaLabel');

    public onBadgeClick(btn: ButtonViewModel) {
        this.badgeClick.emit(btn);
    }

    public get isNativeApp(): boolean {
        return this.uaService.isMobile() || this.uaService.isTablet() || this.isMobileWidth();
    }
}
